import * as Yup from 'yup';

import { ShowPlaybackMode } from './Event.types';

// Form inputs keep time/repetition as strings; validate as strings so an
// unused empty field (e.g. repetition while in TIME mode) is not cast to NaN.
export const MAX_SHOW_TIME_SECONDS = 3600;

const isNumberInRange = (min: number, max = Number.MAX_SAFE_INTEGER) => (
  value?: string | null,
) => {
  const number = Number(value);
  return !!value && Number.isFinite(number) && number >= min && number <= max;
};

export const showsValidationSchema = Yup.array()
  .of(
    Yup.object().shape({
      arrangementId: Yup.number().required('Show is a required field'),
      time: Yup.string().when('playbackMode', {
        is: ShowPlaybackMode.TIME,
        then: Yup.string().test(
          'positive-time',
          'Time must be a number between 1 and 3600',
          isNumberInRange(1, MAX_SHOW_TIME_SECONDS),
        ),
        otherwise: Yup.string().notRequired(),
      }),
      repetition: Yup.string().when('playbackMode', {
        is: ShowPlaybackMode.REPETITION,
        then: Yup.string().test(
          'repetition-range',
          'Repetition must be a number between 1 and 100',
          isNumberInRange(1, 100),
        ),
        otherwise: Yup.string().notRequired(),
      }),
    }),
  )
  .min(1, 'At least one show is required')
  .required('At least one show is required');
